import { AlertTriangleOutline, SuccessCircleOutline, LoadingOutline } from '@olist/design-system-icons';
import React from 'react';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';
import { FeedbackIcon } from './styles.js';

var feedbackIcon = {
    error: React.createElement(AlertTriangleOutline, null),
    valid: React.createElement(SuccessCircleOutline, null),
};
var SuprefixContent = function (_a) {
    var El = _a.el, isLoading = _a.isLoading, feedback = _a.feedback, hasInteractiveEl = _a.hasInteractiveEl;
    var isValidComponent = function (El) {
        return typeof El === 'function';
    };
    return (React.createElement(React.Fragment, null, hasInteractiveEl ? (React.createElement(FeedbackIcon, { isLoading: isLoading, feedback: feedback, "aria-hidden": "true" }, isLoading ? React.createElement(LoadingOutline, null) : feedback && feedbackIcon[feedback])) : El && isValidComponent(El) ? (React.createElement(El, { "aria-hidden": "true" })) : (React.createElement(ParagraphMd, null, El))));
};

export { SuprefixContent };
